var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7 3H17C20 3 22 4.5 22 8V11.14C22 11.87 21.25 12.33 20.58 12.04C19.48 11.56 18.23 11.38 16.92 11.59C14.3 12.02 12.16 14.09 11.63 16.69C11.48 17.45 11.46 18.19 11.56 18.9C11.64 19.49 11.16 20.01 10.57 20.01H7C4 20.01 2 18.51 2 15.01V8.01001C2 4.50001 4 3 7 3Z",
    fill: "#333448"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.87C11.16 11.87 10.31 11.61 9.66003 11.08L6.53002 8.57996C6.21002 8.31996 6.15003 7.84997 6.41003 7.52997C6.67003 7.20997 7.14001 7.14997 7.46001 7.40997L10.59 9.90997C11.35 10.52 12.64 10.52 13.4 9.90997L16.53 7.40997C16.85 7.14997 17.33 7.19997 17.58 7.52997C17.84 7.84997 17.79 8.32996 17.46 8.57996L14.33 11.08C13.69 11.61 12.84 11.87 12 11.87Z",
    fill: "#333448"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13C15.24 13 13 15.23 13 18C13 20.76 15.24 23 18 23C20.77 23 23 20.76 23 18C23 15.23 20.77 13 18 13ZM20.05 17.55L19.68 17.91L17.51 20.09C17.41 20.18 17.22 20.28 17.08 20.3L16.1 20.44C15.75 20.49 15.5 20.24 15.55 19.89L15.69 18.91C15.71 18.77 15.8 18.58 15.9 18.48L18.08 16.31L18.44 15.94C18.68 15.7 18.95 15.54 19.23 15.54C19.47 15.54 19.74 15.65 20.04 15.94C20.7 16.6 20.49 17.11 20.05 17.55Z",
    fill: "#333448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.b78b968aa3be6d9bd7c60922c043e171.svg";
export { ForwardRef as ReactComponent };